export default {"src":"https://fishbrain.com/_next/static/media/nebraska.8917da0c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};